import { InfoTooltip } from "../../../shared/InfoTooltip";

export const LegendChartsIcon: React.FC<{ label: string; tooltip?: string }> = ({ label, tooltip }) => {
    return (
        <div key={label} className="custom-legend-item">
            <svg width="40" height="20" viewBox="0 0 40 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>{label}</title>
                <path d="M0 0L40 8.9375V13H0V0Z" fill="#293F3E" />
                <path d="M0 5L40 11.5V18H0V5Z" fill="#516966" />
                <path d="M0 12.5L40 17V19.5H0V12.5Z" fill="#7C9593" />
            </svg>
            {label}

            {tooltip && <InfoTooltip text={tooltip} />}
        </div>
    );
};
